// Recovered compiled webpack factory 63886. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "HTTPAccessFallbackBoundary", {
      enumerable: !0,
      get: function () {
        return c;
      },
    }));
  let n = r(49417),
    a = r(95155),
    o = n._(r(12115)),
    i = r(51486),
    s = r(37099);
  r(94781);
  let l = r(46752);
  class u extends o.default.Component {
    componentDidCatch() {}
    static getDerivedStateFromError(e) {
      if ((0, s.isHTTPAccessFallbackError)(e))
        return { triggeredStatus: (0, s.getAccessFallbackHTTPStatus)(e) };
      throw e;
    }
    static getDerivedStateFromProps(e, t) {
      return e.pathname !== t.previousPathname && t.triggeredStatus
        ? { triggeredStatus: void 0, previousPathname: e.pathname }
        : { triggeredStatus: t.triggeredStatus, previousPathname: e.pathname };
    }
    render() {
      let { notFound: e, forbidden: t, unauthorized: r, children: n } = this.props,
        { triggeredStatus: o } = this.state,
        i = {
          [s.HTTPAccessErrorStatus.NOT_FOUND]: e,
          [s.HTTPAccessErrorStatus.FORBIDDEN]: t,
          [s.HTTPAccessErrorStatus.UNAUTHORIZED]: r,
        };
      if (o) {
        let l = o === s.HTTPAccessErrorStatus.NOT_FOUND && e,
          u = o === s.HTTPAccessErrorStatus.FORBIDDEN && t,
          c = o === s.HTTPAccessErrorStatus.UNAUTHORIZED && r;
        return l || u || c
          ? (0, a.jsxs)(a.Fragment, {
              children: [(0, a.jsx)("meta", { name: "robots", content: "noindex" }), !1, i[o]],
            })
          : n;
      }
      return n;
    }
    constructor(e) {
      (super(e), (this.state = { triggeredStatus: void 0, previousPathname: e.pathname }));
    }
  }
  function c(e) {
    let { notFound: t, forbidden: r, unauthorized: n, children: s } = e,
      c = (0, i.useUntrackedPathname)(),
      f = (0, o.useContext)(l.MissingSlotContext);
    return t || r || n
      ? (0, a.jsx)(u, {
          pathname: c,
          notFound: t,
          forbidden: r,
          unauthorized: n,
          missingSlots: f,
          children: s,
        })
      : (0, a.jsx)(a.Fragment, { children: s });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
